import { StaticPageTemplate } from 'components/domain/staticPages/StaticPageTemplate'
import { previewStaticPage } from 'lib/api'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { NotFound } from './NotFound'

type LoadState = { status: 'loading' } | { status: 'loaded'; html: string } | { status: 'error' }

// Authenticated preview opened from the backoffice: same template as the public viewer, but it hits
// the permission-gated endpoint so drafts render too. Auth rides on the session cookie.
export const StaticPagePreview = (): JSX.Element => {
  const { id, locale } = useParams<{ id: string; locale: string }>()
  const [state, setState] = useState<LoadState>({ status: 'loading' })

  useEffect(() => {
    let cancelled = false

    previewStaticPage(Number(id), locale ?? 'en')
      .then(({ html }) => {
        if (!cancelled) setState({ status: 'loaded', html })
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' })
      })

    return () => {
      cancelled = true
    }
  }, [id, locale])

  if (state.status === 'loading') {
    return <div className="static-page__status">Loading…</div>
  }

  if (state.status === 'error') {
    return <NotFound />
  }

  return <StaticPageTemplate html={state.html} />
}
